export const disputeHeading = [
    { name: "ID" },
    { name: "FULLNAME" },
    { name: "AMOUNT" },
    { name: "DISPUTE NOTES" },
    { name: "ACTION", width: 50 },
]